import SectionHorizontalIconTextList from "apps/website/components/section/SectionHorizontalItemTextList/SectionHorizontalIconTextList";
import {
  sectionHorizontalItemTextListData,
} from "apps/website/components/section/SectionHorizontalItemTextList/shared/data";

export default function SectionFreeTrial() {
  return (
    <SectionHorizontalIconTextList { ...sectionHorizontalItemTextListData} />
  );
}
